var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "profile",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 39,
    fill: "#008EFF",
    stroke: "#008EFF",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#profile)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 39,
    fill: "#E0E0E0",
    stroke: "#E0E0E0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default-profile2)",
    fill: "#828282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.856 69.504c-.78-5.051-1.423-6.988-8.472-7.796-2.677-.303-9.964-1.044-12.675-2.593-2.71-1.549-2.287-9.227-2.287-9.227H33.595s.424 7.695-2.287 9.227-9.998 2.324-12.675 2.593c-7.066.808-7.71 2.728-8.472 7.796A77.169 77.169 0 009.449 79H72.5a81.088 81.088 0 00-.644-9.496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.968 58.576c4.897.101 13.167-1.06 16.504-5.135 0-.707-.084-1.38-.101-1.953v-.522c-.01-.14-.01-.28 0-.421v-.522H33.595s.356 6.247-1.627 8.553z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.673 30.66h-.339c.136-1.128.289-2.222.424-3.283.712-5.422 2.322-21.3-16.758-21.3s-17.47 15.878-16.758 21.3c.135 1.06.27 2.155.423 3.283h-.339c-2.897-2.138-3.151 3.368-1.931 5.354a11.604 11.604 0 011.694 3.469c.44 1.296 1.186 1.465 1.813 1.313 0 .758.136 1.431.187 1.953.27 2.93 7.354 8.79 8.963 10.625 1.61 1.835 6.29 2.252 7.086 2.218 2.278 0 3.522-.484 4.945-2.218 1.423-1.735 8.693-7.695 8.964-10.625 0-.522.101-1.195.186-1.953.627.152 1.356 0 1.813-1.313a11.22 11.22 0 011.695-3.469c1.067-1.92.83-7.492-2.068-5.354z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.156 37.429s-.27-8.217.509-9.497c.78-1.28 7.49-6.28 8.2-9.109.408-1.784-2.829-11.095-2.829-11.095s-8.879 0-8.862 14.008c.284 3.008-.731 4.494 0 7.427.608 2.229 2.62 5.985 2.982 8.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.843 37.429s.255-8.217-.508-9.497c-.762-1.28-19.893-6.28-20.469-9.108-.407-1.785-2.83-11.096-2.83-11.096a8.395 8.395 0 015.677-2.492c9.167-1.162 20.621 1.498 21.248 16.5-.245 3.016.792 4.506 0 7.427-.642 2.227-2.721 5.983-3.117 8.266zM72.5 79a81.066 81.066 0 00-.644-9.496c-.78-5.052-1.423-6.988-8.472-7.796a88.41 88.41 0 01-9.049-1.364s-6.88 4.075-13.301 4.092c-6.422.016-13.302-4.092-13.302-4.092a88.624 88.624 0 01-9.065 1.364c-7.066.808-7.71 2.728-8.472 7.796A77.17 77.17 0 009.449 79H72.5z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "default-profile2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9.5 5)",
    d: "M0 0h63v74H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.10a14f4c.svg";
export { ForwardRef as ReactComponent };